<script>
export default {
  name: 'RenderNode',
  props: {
    node: {
      type: Object,
      required: true,
    },
  },
  render(createElement) {
    return createElement('div', [this.node]);
  },
};
</script>
